<script lang="ts">
    import { _ } from 'svelte-i18n';

    import type { CalculationPeriodType } from '../settings';
    import Select from '../../../shared/Select.svelte';
    import { customerSettings } from '../../../../stores/api';
    import DaysOfWeek from './DaysOfWeek.svelte';
    import DaysOfMonth from './DaysOfMonth.svelte';

    export let period: CalculationPeriodType;
    export let updateCustomer: () => void;
    /** Konto bez can_write widzi harmonogram, ale go nie zmienia (US-023). */
    export let disabled: boolean = false;

    function getPeriodTypeItems() {
        return [
            { id: 'days_of_week', label: $_('days_of_week') },
            { id: 'days_of_month', label: $_('days_of_month') },
        ];
    }
</script>

<div class="calculation-period-manager-container">
    <Select
        bind:selected={$customerSettings.calculations.period.selected_method}
        items={getPeriodTypeItems()}
        {disabled}
        onChange={() => {
            updateCustomer();
            return true;
        }}
    />
    {#if $customerSettings.calculations.period.selected_method === 'days_of_week'}
        <DaysOfWeek
            daysOfWeek={$customerSettings.calculations.period.days_of_week}
            {disabled}
            onChange={daysOfWeek => {
                $customerSettings.calculations.period.days_of_week = daysOfWeek;
                updateCustomer();
            }}
        />
    {:else if $customerSettings.calculations.period.selected_method === 'days_of_month'}
        <DaysOfMonth
            daysOfMonth={$customerSettings.calculations.period.days_of_month}
            {disabled}
            onChange={daysOfMonth => {
                $customerSettings.calculations.period.days_of_month = daysOfMonth;
                updateCustomer();
            }}
        />
    {/if}
</div>

<style>
    .calculation-period-manager-container {
        display: flex;
        flex-direction: column;
        row-gap: 3px;
    }
</style>
